/** Stable file kind for icons (no react-icons reference equality). */
export type AttachmentFileKind =
  | "image"
  | "video"
  | "audio"
  | "pdf"
  | "word"
  | "sheet"
  | "slides"
  | "archive"
  | "text"
  | "code"
  | "file";

export function resolveAttachmentFileKind(contentType: string, fileName: string): AttachmentFileKind {
  const x = (contentType || "").toLowerCase();
  const n = (fileName || "").toLowerCase();

  if (x.startsWith("image/")) return "image";
  if (x.startsWith("video/")) return "video";
  if (x.startsWith("audio/")) return "audio";
  if (/\.(mov|mkv|webm|mp4|m4v|avi|wmv)$/i.test(n)) return "video";
  if (/\.(png|jpe?g|gif|webp|svg|bmp|heic)$/i.test(n)) return "image";
  if (x === "application/pdf") return "pdf";
  if (x.includes("word") || x.includes("msword") || x.includes("wordprocessingml") || /\.(docx?)$/i.test(n))
    return "word";
  if (
    x.includes("sheet") ||
    x.includes("excel") ||
    x.includes("spreadsheetml") ||
    /\.(xlsx?|csv|ods)$/i.test(n)
  )
    return "sheet";
  if (
    x.includes("presentation") ||
    x.includes("powerpoint") ||
    x.includes("presentationml") ||
    /\.pptx?$/i.test(n)
  )
    return "slides";
  if (
    x.includes("zip") ||
    x.includes("rar") ||
    x.includes("x-tar") ||
    x.includes("gzip") ||
    /\.(zip|rar|7z|tar|gz|tgz)$/i.test(n)
  )
    return "archive";
  if (x.startsWith("text/") || /\.(txt|md|log|rtf)$/i.test(n)) return "text";
  if (
    x.includes("javascript") ||
    x.includes("typescript") ||
    x.includes("json") ||
    /\.(js|cjs|mjs|ts|tsx|jsx|json|html?|css|scss|vue|svelte)$/i.test(n)
  )
    return "code";
  return "file";
}
